import { Link } from 'react-router-dom';
import type { Post } from '@/mocks/posts';

interface PostListProps {
  posts: Post[];
  categoryName: string;
  categoryDescription: string;
}

export default function PostList({ posts, categoryName, categoryDescription }: PostListProps) {
  if (posts.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-200 flex items-center justify-center">
          <i className="ri-inbox-line text-2xl text-foreground-400 w-8 h-8 flex items-center justify-center"></i>
        </div>
        <p className="text-foreground-600">该分类下暂无文章</p>
        <Link
          to="/"
          className="inline-block mt-4 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
          {categoryName}
        </h2>
        <p className="text-sm text-foreground-600">{categoryDescription}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {posts.map((post) => (
          <Link
            key={post.id}
            to={`/article/${post.slug}`}
            className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={post.coverImage}
                alt={post.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-3 mb-2">
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                  {post.category}
                </span>
                <span className="text-xs text-foreground-400">{post.publishDate}</span>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                {post.title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                {post.excerpt}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-heart-line w-3 h-3 flex items-center justify-center"></i>
                  {post.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-1-line w-3 h-3 flex items-center justify-center"></i>
                  {post.comments.toLocaleString()}
                </span>
                <span>{post.readTime} 分钟</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}